import {React,useState} from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardMedia, Typography, Button,Menu,MenuItem } from '@mui/material';
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import Organization from '..';

const Detail = ( ({ view ,edit , deleterec }) => {
  
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <Card sx={{  boxShadow: 3 }}>
       <MDBox sx={{ position: 'absolute', top: 8, right: 8 }}>
        <MDButton onClick={handleMenuOpen}>
              I
        </MDButton>
          <Menu
            anchorEl={anchorEl}
            open={isMenuOpen}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
          <MenuItem onClick={() => edit(view)}>Edit</MenuItem>
          {/* <MenuItem onClick={() => deleteOrganization(view)}>Delete</MenuItem> */}
        </Menu>
      </MDBox>
      <CardContent>
        <Typography variant="h5" component="div" gutterBottom>
          {view.username}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Email:</strong> {view.email}  
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Date:</strong> {new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(view.createdAt))}
        </Typography>
      </CardContent>
    </Card>
  );
});
Detail.propTypes = {
  view:PropTypes.object.isRequired,
  edit: PropTypes.func.isRequired,
  deleterec: PropTypes.func.isRequired
};
export default Detail;
